var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig } from "@jti/fe-common";
import { CasProfileApi, CasPurposesApi, getUser } from "@jti/rest-api";
const checkAgeRestriction = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { is_age_verified } = yield CasProfileApi.init().getProfile(true);
        return is_age_verified;
    }
    catch (error) {
        console.error("Error while checking age restriction", error);
        return false;
    }
});
const checkPurposeRestriction = (loyaltyRestrictionPurpose) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const data = yield CasPurposesApi.init().getPurposesForUserByCategory("all", true);
        const filteredPurposes = data
            .filter(({ id }) => loyaltyRestrictionPurpose.includes(id))
            .map(({ id, accepted }) => ({ id, accepted }));
        return filteredPurposes;
    }
    catch (error) {
        console.error("Error while checking purpose restriction", error);
        return [];
    }
});
export const isLoyaltyRestricted = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { IS_LOYALTY_ENABLED, loyaltyRestrictionPurpose, isLoyaltyContentRestricted, isAgeVerifiedLoyaltyRestriction, isDeviceRegisteredRestriction, } = getConfig();
    const isLoyaltyEnabled = IS_LOYALTY_ENABLED === "true";
    if (isLoyaltyContentRestricted && isLoyaltyEnabled) {
        const isAgeVerified = isAgeVerifiedLoyaltyRestriction ? yield checkAgeRestriction() : true;
        if (!isAgeVerified) {
            return true;
        }
        const isDeviceVerified = isDeviceRegisteredRestriction ? !!((_a = getUser()) === null || _a === void 0 ? void 0 : _a.is_device_registered) : true;
        if (!isDeviceVerified) {
            return true;
        }
        const isPurposeRestricted = loyaltyRestrictionPurpose.length > 0;
        const purposesStatusList = isPurposeRestricted ? yield checkPurposeRestriction(loyaltyRestrictionPurpose) : [];
        const isPurposesVerified = purposesStatusList.every(({ accepted }) => accepted);
        if (!isPurposesVerified) {
            return true;
        }
    }
    return false;
});
//# sourceMappingURL=isLoyaltyRestricted.js.map